var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var ProducTitle = function (_a) {
    var title = _a.title;
    return (React.createElement(Style, null, title));
};
var Style = styled.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 0 8px;\n    font-size: 28px;\n    font-weight: 700;\n    color: #333;\n    line-height: 40px;\n"], ["\n    margin: 0 0 8px;\n    font-size: 28px;\n    font-weight: 700;\n    color: #333;\n    line-height: 40px;\n"])));
export default ProducTitle;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/product_head/product_title.tsx
// module id = 179
// module chunks = 0